module.exports = __webpack_public_path__ + "img/1569038564.ca3ee269.jpg";